import { useState } from 'react';
import {
    Form,
    Button,
    Input,
    Alert,
} from 'antd';
import { useTranslation } from 'react-i18next';

import { getErrorMessage } from '../../utils/messages';
import { forgotPassword } from '../../api/auth.api';

const ResetForm = () => {
    const { t } = useTranslation('login');

    const [error, setError] = useState<string | null>(null);
    const [message, setMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = ({ email }: { email: string}) => {
        setLoading(true);
        setError(null);
        setMessage(null);

        const role = 'deliveryPartner';
        const payload = {
            email, role,
        };
        forgotPassword(payload)
            .then((response: any) => {
                const description = getErrorMessage(response.message);
                setMessage(t(description));
            })
            .catch((error) => {
                const description = getErrorMessage(error?.error || error?.message);
                setError(t(description));
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Form onFinish={handleSubmit} layout="vertical">
            {
                (error) && (<Alert message={error} type="error" style={{ marginBottom: 24 }} />)
            }
            {
                (message) && (<Alert message={message} type="success" style={{ marginBottom: 24 }} />)
            }
            <Form.Item
                name="email"
                label={t('EMAIL')}
                rules={[
                    { type: 'email', message: t('INVALID_EMAIL') },
                    { required: true, message: t('REQUIRED') },
                ]}
            >
                <Input placeholder={t('EMAIL')} />
            </Form.Item>

            <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                block
            >
                {t('RESET_PASSWORD')}
            </Button>
        </Form>
    );
};

export default ResetForm;
